import { jsx } from "react/jsx-runtime";
import { UrlInputFieldWUT } from "../../../ui/url-input-field/url-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const UrlInputWUT = (props) => {
  const fieldType = FIELD_TYPES.URL_INPUT;
  return /* @__PURE__ */ jsx(UrlInputFieldWUT, { ...props, fieldType });
};
export {
  UrlInputWUT
};
//# sourceMappingURL=url-input-wut.js.map
